<!--
 * @Author: Junjie
 * @Date: 2022-12-15 14:19:47
 * @LastEditTime: 2022-12-15 15:28:54
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/equipment/account/vue/modules/DevLifeCycleModal.vue
-->
<template>
  <j-modal
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    cancelText="关闭"
    switchFullscreen
  >
    <a-timeline mode="alternate">
      <a-timeline-item
        :color="item.service_status === 'retire' ? 'red' : 'green'"
        :key="item.id"
        v-for="item in dataSource"
      >
        <a-icon slot="dot" style="font-size: 16px;" type="clock-circle-o" />
        <p>{{`厂家：${item.manu_name}` }}</p>
        <p>{{`型号：${item.model_name}`}}</p>
        <p>{{`${item.operation_date}投运` }}</p>
        <p v-if="item.service_status === 'retire'">{{`${item.retire_date}退役` }}</p>
        <p>{{`投运时长${item.continiounsDays}天` }}</p>
      </a-timeline-item>
    </a-timeline>
  </j-modal>
</template>

<script>

  import { getAction } from '@/api/manage'
  import moment from 'dayjs'

  export default {
    name: 'DevLifeCycleModal',
    components: {

    },
    data () {
      return {
        title: '设备生命周期',
        width: 900,
        visible: false,
        disableSubmit: true,
        dataSource: [],
        url: {
          getDevListLifeCycle: '/device/devList/getDevListLifeCycle',
        },
      }
    },
    methods: {
      show (alertId) {
        this.visible = true
        this.$nextTick(() => {
          this.loadData(alertId);
        });
      },
      loadData (devTag) {
        getAction(this.url.getDevListLifeCycle, { devTag }).then(res => {
          if (res.success) {
            res.result.forEach(item => {
              item.continiounsDays = item.retire_date ? moment(item.retire_date).diff(moment(item.operation_date), 'days') : moment().diff(moment(item.operation_date), 'days')
            });

            this.dataSource = res.result
          } else {
            this.$message.warning(res.message)
          }
        });
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>